import { productionService } from "@/services/productionService";
import { previewService } from "@/services/previewService";
import type { Service } from "@/types/Service";
import { IS_PRODUCTION } from "@/config";

export function getService(): Service {
  const searchParams = new URLSearchParams(window.location.search);
  const hasPreviewParam = searchParams.get("mode") === "preview";

  const IS_PREVIEW =
    (hasPreviewParam && !IS_PRODUCTION) || window.__FORM_MODE__ === "preview";

  return IS_PREVIEW ? previewService : productionService;
}
